import clsx from 'clsx';

import { ShowNumber } from '../../common';
import { HintIcon } from './HintIcon';
import { ParameterRowProps } from './ParameterRowProps';
import { useStyles } from './styles';

export const ParameterRow = ({
  parameter: { title, value, percent, component, noPrefix, hint, valueHint, percentHint },
  index,
}: ParameterRowProps): JSX.Element => {
  const classes = useStyles();

  return (
    <tr
      key={index}
      className={clsx(classes.row, {
        [classes.bordered]: !!index,
      })}
    >
      <td>
        {title}:
        <HintIcon hint={hint} />
      </td>
      {component ? (
        <td width="10%" className={classes.value}>
          {component}
        </td>
      ) : (
        <>
          {value !== undefined && (
            <td width="10%" className={classes.value}>
              <span style={{ whiteSpace: 'nowrap' }}>
                <ShowNumber number={value} {...(!noPrefix && { prefix: '$' })} withAnimation condensed />
                <HintIcon hint={valueHint} marginRight />
              </span>
            </td>
          )}
          {percent !== undefined && (
            <td width="0%" className={classes.value}>
              <span style={{ whiteSpace: 'nowrap' }}>
                {<ShowNumber number={percent} suffix="%" withAnimation condensed />}
                <HintIcon hint={percentHint} marginRight />
              </span>
            </td>
          )}
        </>
      )}
    </tr>
  );
};
